module.exports = __webpack_public_path__ + "img/MEDIA075.ab91b16f.jpg";